export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'

export const GET_ALL_USER_CREDIT = 'GET_ALL_USER_CREDIT'
export const GET_ALL_COUPONS = 'GET_ALL_COUPONS'
export const GET_SINGLE_COUPON = 'GET_SINGLE_COUPON'
export const GET_ALL_USED_COUPONS = 'GET_ALL_USED_COUPONS'
